import React, { useState } from 'react';
import Form from '@rjsf/core';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Badge } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AccordionTemplate = ({
  schema,
  uiSchema,
  idSchema,
  formData,
  errors,
  registry,
  onChange,
  ...rest
}) => {
  const { fields } = registry;
  const ObjectField = fields.ObjectField;
  const { name, ...remainingProps } = rest;
  const [expanded, setExpanded] = useState('Essential Business Information' === schema.title);
  const schemaWithoutTitle = { ...schema, title: undefined };

  const handleAccordionChange = section => (_, isExpanded) => {
    setExpanded(isExpanded ? section : null);
  };

  const hasErrors = sectionKey => {
    const sectionErrorKeys = Object.keys(errors || {}).filter(key =>
      key.startsWith(`${idSchema[sectionKey].$id}`),
    );
    return sectionErrorKeys.length > 0;
  };

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  //   return (
  //     <>
  //       {Object.entries(schema.properties).map(([sectionKey, sectionSchema]) => {
  //         const sectionHasErrors = hasErrors(sectionKey);
  //         return (
  //           <Accordion
  //             key={sectionKey}
  //             expanded={expanded === sectionKey}
  //             onChange={handleAccordionChange(sectionKey)}
  //           >
  //             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
  //               <Badge
  //                 color="error"
  //                 badgeContent={sectionHasErrors ? "!" : 0}
  //                 invisible={!sectionHasErrors}
  //               >
  //                 <Typography>{sectionSchema.title}</Typography>
  //               </Badge>
  //             </AccordionSummary>
  //             <AccordionDetails>
  //               <ObjectField
  //                 schema={{ ...sectionSchema, title: undefined }}
  //                 uiSchema={uiSchema[sectionKey] || {}}
  //                 idSchema={idSchema[sectionKey]}
  //                 formData={formData[sectionKey]}
  //                 registry={registry}
  //                 onChange={(data) =>
  //                   onChange({ ...formData, [sectionKey]: data })
  //                 }
  //                 {...rest}
  //               />
  //             </AccordionDetails>
  //           </Accordion>
  //         );
  //       })}
  //     </>
  //   );
  // };

  return (
    <Accordion expanded={expanded} onChange={handleChange(schema.title)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">{schema.title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ObjectField
          schema={schemaWithoutTitle}
          uiSchema={uiSchema}
          idSchema={idSchema}
          formData={formData}
          registry={registry}
          onChange={onChange}
          {...remainingProps}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionTemplate;
